import { types } from './actions';

const DEFAULT_NEXT_CURSOR = { first: null, cursorPosition: null };
const DEFAULT_PREV_CURSOR = { last: null, cursorPosition: null };
const DEFAULT_PAGE_SIZE = 20;

const initalState = {
  district: null,
  department: null,
  perDiemId: null,
  perDiemState: null,
  user: '',
  ticketJobNumber: '',
  requestedAt: '',
  requestedForDate: '',
  paymentDate: '',
  tableDataRequest: true,
  sorted: [{
    id: 'requested_at',
    desc: true,
    order: 1,
  }],

  /* NOTE: Sets the number of rows shown in the react table */
  pageSize: DEFAULT_PAGE_SIZE,

  /* NOTE: default values to fire off query */
  nextCursorObject: { first: DEFAULT_PAGE_SIZE, cursorPosition: null },
  prevCursorObject: DEFAULT_PREV_CURSOR,
};

const reducer = (state = initalState, action) => {
  switch (action.type) {
    case types.SET_DISTRICT: {
      const { district } = action;
      const { pageSize } = state;
      return {
        ...state,
        district,
        nextCursorObject: { first: pageSize, cursorPosition: null },
        prevCursorObject: DEFAULT_PREV_CURSOR,
      };
    }
    case types.SET_DEPARTMENT: {
      const { department } = action;
      const { pageSize } = state;
      return {
        ...state,
        department,
        nextCursorObject: { first: pageSize, cursorPosition: null },
        prevCursorObject: DEFAULT_PREV_CURSOR,
      };
    }
    case types.SET_PER_DIEM_ID: {
      const { perDiemId } = action;
      const { pageSize } = state;
      return {
        ...state,
        perDiemId,
        nextCursorObject: { first: pageSize, cursorPosition: null },
        prevCursorObject: DEFAULT_PREV_CURSOR,
      };
    }
    case types.SET_PER_DIEM_STATE: {
      const { perDiemState } = action;
      const { pageSize } = state;
      return {
        ...state,
        perDiemState,
        nextCursorObject: { first: pageSize, cursorPosition: null },
        prevCursorObject: DEFAULT_PREV_CURSOR,
      };
    }
    case types.SET_TICKET_JOB_NUMBER: {
      const { ticketJobNumber } = action;
      const { pageSize } = state;
      return {
        ...state,
        ticketJobNumber,
        nextCursorObject: { first: pageSize, cursorPosition: null },
        prevCursorObject: DEFAULT_PREV_CURSOR,
      };
    }
    case types.SET_USER: {
      const { user } = action;
      const { pageSize } = state;
      return {
        ...state,
        user,
        nextCursorObject: { first: pageSize, cursorPosition: null },
        prevCursorObject: DEFAULT_PREV_CURSOR,
      };
    }

    case types.SET_REQUESTED_AT_DATE: {
      const { requestedAt } = action;
      const { pageSize } = state;
      return {
        ...state,
        requestedAt,
        nextCursorObject: { first: pageSize, cursorPosition: null },
        prevCursorObject: DEFAULT_PREV_CURSOR,
      };
    }
    case types.SET_REQUESTED_FOR_DATE: {
      const { requestedForDate } = action;
      const { pageSize } = state;
      return {
        ...state,
        requestedForDate,
        nextCursorObject: { first: pageSize, cursorPosition: null },
        prevCursorObject: DEFAULT_PREV_CURSOR,
      };
    }
    case types.SET_PAYMENT_DATE: {
      const { paymentDate } = action;
      const { pageSize } = state;
      return {
        ...state,
        paymentDate,
        nextCursorObject: { first: pageSize, cursorPosition: null },
        prevCursorObject: DEFAULT_PREV_CURSOR,
      };
    }
    case types.SET_FILTERING_VALUES: {
      const { filteringValues } = action;
      const { pageSize } = state;
      return {
        ...state,
        ...filteringValues,
        nextCursorObject: { first: pageSize, cursorPosition: null },
        prevCursorObject: DEFAULT_PREV_CURSOR,
      };
    }
    case types.CLEAR_FILTERING_VALUES: {
      const { pageSize } = state;
      return {
        ...initalState,
        nextCursorObject: { first: pageSize, cursorPosition: null },
        prevCursorObject: DEFAULT_PREV_CURSOR,
      };
    }
    case types.SET_TABLE_DATA_REQUEST: {
      const { tableDataRequest } = action;
      const { pageSize } = state;
      return {
        ...state,
        tableDataRequest,
        nextCursorObject: { first: pageSize, cursorPosition: null },
        prevCursorObject: DEFAULT_PREV_CURSOR,
      };
    }

    case types.SET_TABLE_ORDER: {
      const { sorted } = action;
      return {
        ...state,
        sorted,
      };
    }

    case types.SET_PAGE_SIZE: {
      const { pageSize } = action;
      return {
        ...state,
        pageSize,
        nextCursorObject: { first: pageSize, cursorPosition: null },
        prevCursorObject: DEFAULT_PREV_CURSOR,
      };
    }

    case types.SET_PREV_CURSOR: {
      const { prevCursor } = action;
      const { pageSize } = state;
      return {
        ...state,
        prevCursorObject: { last: pageSize, cursorPosition: prevCursor },
        nextCursorObject: DEFAULT_NEXT_CURSOR,
      };
    }

    case types.SET_NEXT_CURSOR: {
      const { nextCursor } = action;
      const { pageSize } = state;
      return {
        ...state,
        nextCursorObject: { first: pageSize, cursorPosition: nextCursor },
        prevCursorObject: DEFAULT_PREV_CURSOR,
      };
    }

    default:
      return state;
  }
};

export default reducer;
